export const ASSET_TYPE_UPLOAD = 1;
export const ASSET_TYPE_VIEW = 2;
export const ASSET_TYPE_EDIT = 3;
